import Keycloak from 'keycloak-js';
import { getEnv } from '@common/utilities/env';

// Setup Keycloak instance as needed
// Pass initialization options as required or leave blank to load from 'keycloak.json'
const keycloak = new Keycloak({
  url: getEnv('REACT_APP_KEYCLOAK_BASE_URL'),
  realm: 'ec',
  clientId: getEnv('REACT_APP_KEYCLOAK_CLIENT_ID') ?? 'ec_web'
});

export default keycloak;
